/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { WithSerialNumber } from './WithSerialNumber';
import {
    instanceOfWithSerialNumber,
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';

/**
 * @type EquipmentTypeCatalogDtoWithSerialNumber
 * 
 * @export
 */
export type EquipmentTypeCatalogDtoWithSerialNumber = WithSerialNumber;


export function EquipmentTypeCatalogDtoWithSerialNumberFromJSON(json: any): EquipmentTypeCatalogDtoWithSerialNumber {
    return EquipmentTypeCatalogDtoWithSerialNumberFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoWithSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDtoWithSerialNumber {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...WithSerialNumberFromJSONTyped(json, true) };
    return  WithSerialNumberFromJSONTyped(json, true);
}

export function EquipmentTypeCatalogDtoWithSerialNumberToJSON(value?: EquipmentTypeCatalogDtoWithSerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfWithSerialNumber(value)) {
        return WithSerialNumberToJSON(value as WithSerialNumber);
    }

    return {};
}

/**
 * Check if a given object implements the EquipmentTypeCatalogDtoWithSerialNumber interface.
 */
export function instanceOfEquipmentTypeCatalogDtoWithSerialNumber(value: any): value is EquipmentTypeCatalogDtoWithSerialNumber {
    if (instanceOfWithSerialNumber(value)) return true;
    return false;
}

